define(
    'utils/dim',[
        'jquery',

        'libs/inject-style/inject-style'
    ],
    function ($, injector) {
        var Dim = (function () {
            var
            dim,

            /**
             * The length of the fade in/fade out in seconds
             *
             * @property transitionTime
             * @type {float}
             */
            transitionTime = 0.5;

            function Dim(tint) {
                if (dim === undefined) {
                    dim = $('<div id="dim"></div>').appendTo('body');
                    dim.hide();

                    var transition = transitionTime + 's opacity ease';

                    injector.addRule('#dim', {
                        'position': 'fixed',
                        'z-index': '100',
                        'left': 0,
                        'top': 0,
                        'right': 0,
                        'bottom': 0,
                        'background': tint,
                        'opacity': '0',
                        'transition': transition,
                        '-webkit-transition': transition,
                        '-moz-transition': transition
                    });
                }
            }

            /**
             * Dim down the page
             *
             * @method dim
             */
            Dim.prototype.dim = function () {
                dim.show();
                setTimeout(function () {
                    dim.css('opacity', '0.5');
                }, 0);
            };

            /**
             * Clear the dim
             *
             * @method clear
             */
            Dim.prototype.clear = function () {
                dim.css('opacity', '0');
                setTimeout(function () {
                    dim.hide();
                }, transitionTime * 1000);
            };

            return Dim;
        })();

        return new Dim('#fff');
    }
);
